// MapLibre and TerraDraw are loaded from CDN as render-blocking scripts so the
// browser can cache them independently. Keep the global references in sync.
window.maplibregl = window.maplibregl;
window.MaplibreTerradrawControl = window.MaplibreTerradrawControl;

// Tree-shake @turf/turf to only the helpers actually used by the app.
import { distance, length, area, lineString, polygon, centroid } from '@turf/turf';
window.turf = { distance, length, area, lineString, polygon, centroid };
